import { render, staticRenderFns } from "./OtherV4.vue?vue&type=template&id=cf7e34c0&"
import script from "./OtherV4.vue?vue&type=script&lang=ts&"
export * from "./OtherV4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports